// extracted by mini-css-extract-plugin
module.exports = {"root":"CardPage_root__SZ-BJ"};